import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@chakra-ui/react'
import React, { type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import { useDeleteApplyV2ProfileMutation } from '@core/app/api/applyJobV2Api'
import './CloseApplyModal.scss'

const baseClass = 'CloseApplyModal'

interface CloseApplyModalProps {
    isModalOpen: boolean
    setIsModalOpen: (isOpen: boolean) => void
    onCloseApply: () => void
}

const CloseApplyModal: FC<CloseApplyModalProps> = ({ isModalOpen, setIsModalOpen, onCloseApply }) => {
    const { t } = useTranslation()
    const { storageData } = useApplyV2Context()
    const id = storageData?.id?.toString() || ''
    // const [deleteApplyV2Profile] = useDeleteApplyV2ProfileMutation()

    const handleExit = async () => {
        // const uid = storageData?.postInitUid
        // if (uid) {
        //     try {
        //         await deleteApplyV2Profile({ uid })
        //     } catch (error) {
        //         console.error('Failed to delete apply profile:', error)
        //     }
        //     onCloseApply()
        // }
        onCloseApply()
    }

    return (
        <Modal
            isCentered
            size={'xl'}
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            motionPreset="slideInBottom"
        >
            <ModalOverlay className={`${baseClass}__overlay`} />

            <ModalContent className={`${baseClass}__content`}>
                <ModalHeader className={`${baseClass}__header`}>
                    <Text mb={'14px'} fontWeight={600}>
                        {t('10526', 'Exit application form')}
                    </Text>
                    <ModalCloseButton
                        className={`${baseClass}__close-button`}
                        // top={{
                        //     base: '14px',
                        //     sm: '30px',
                        // }}
                        // right={{
                        //     base: '14px',
                        //     sm: '40px',
                        // }}
                    />
                </ModalHeader>

                <ModalBody
                    className={`${baseClass}__body`}
                    // px={{
                    //     base: '20px',
                    //     sm: '48px',
                    // }}
                    // pb={'0'}
                >
                    <Text
                        fontSize={{
                            base: '14px',
                            sm: '16px',
                        }}
                    >
                        {t('10527', 'Are you sure you want to exit the application form?')}
                    </Text>
                    <Text>{t('10815', 'Any information you have entered will be lost')}.</Text>
                </ModalBody>
                <ModalFooter
                    className={`${baseClass}__footer`}
                    // px={{
                    //     base: '20px',
                    //     sm: '48px',
                    // }}
                    // pb={{
                    //     base: '20px',
                    //     sm: '44px',
                    // }}
                    // pt={{
                    //     base: '20px',
                    //     sm: '40px',
                    // }}
                    display={'flex'}
                    gap={'16px'}
                >
                    <button
                        className={`${baseClass}__footer--btn ${baseClass}__footer--btn-cancel`}
                        type={'button'}
                        onClick={() => setIsModalOpen(false)}
                    >
                        {t('10322', 'Keep applying')}
                    </button>
                    {/*<Button width={'100%'} onClick={() => setIsModalOpen(false)}>*/}
                    {/*    {t('10322', 'Keep applying')}*/}
                    {/*</Button>*/}
                    {/*<Button*/}
                    {/*    width={'100%'}*/}
                    {/*    // variant="primary"*/}
                    {/*    colorScheme={'red'}*/}
                    {/*    onClick={() => {*/}
                    {/*        onCloseApply()*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    {t('10323', 'Exit')}*/}
                    {/*</Button>*/}
                    <button
                        className={`${baseClass}__footer--btn ${baseClass}__footer--btn-confirm`}
                        type={'button'}
                        onClick={handleExit}
                        id={'ra-button-job-post-action-application-form-close-ok'}
                        ra-data-job-post-id={id}
                    >
                        {t('10323', 'Exit')}
                    </button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default CloseApplyModal
